
import React from 'react';
import { Input, Select } from 'antd';

const { Option } = Select;

interface PaginacaoTabelaProps {
    atualizarTabela(paginacaco: number): void;
}

const PaginacaoTabela = (props: PaginacaoTabelaProps) => {
    const { atualizarTabela } = props

    const handleChange = (value: number) => {
        atualizarTabela(value);
    }

    return (
        <div>
            <div className="ant-row ant-form-item">
                <div className="ant-col ant-form-item-label">
                    <label className="ant-form-item-no-colon" title="">
                        <span className="ant-app-text">Paginação</span>
                    </label>
                </div>
                <div className="ant-col ant-form-item-control-wrapper">
                    <div className="ant-form-item-control">
                        <span className="ant-form-item-children">
                            <Select
                                defaultValue="5"
                                style={{ width: 120 }}
                                onChange={handleChange}>
                                <Option value="5">5</Option>
                                <Option value="10">10</Option>
                                <Option value="15">15</Option>
                                <Option value="20">20</Option>
                                <Option value="50">50</Option>
                                <Option value="100">100</Option>
                                <Option value="200">200</Option>
                            </Select>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )

    

}

export default PaginacaoTabela;